import { createAction, handleActions } from 'redux-actions'

const setSorting = createAction('SCREENS/EMAILS/SET_SORTING')

const defaultState = {
  columnKey: 'created_at',
  descending: true,
}

const reducer = handleActions(
  {
    [setSorting]: (state, action) => ({ ...state, ...action.payload }),
  },
  defaultState,
)

export { setSorting, reducer }
